import { cn } from '@/lib/utils';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'hero';
  showIcon?: boolean;
  showText?: boolean;
  className?: string;
}

const sizeClasses = {
  sm: 'text-2xl',
  md: 'text-3xl',
  lg: 'text-4xl',
  xl: 'text-6xl',
  '2xl': 'text-7xl md:text-8xl',
  hero: 'text-7xl md:text-8xl lg:text-9xl',
};

const Logo = ({ size = 'md', showText = true, className }: LogoProps) => {
  const isLarge = size === 'xl' || size === '2xl' || size === 'hero';
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {showText && (
        <span 
          className={cn(
            isLarge ? "font-wordmark-glow" : "font-wordmark",
            "text-gradient-gold",
            sizeClasses[size]
          )}
        >
          Amorette
        </span>
      )}
    </div>
  );
};

export default Logo;
